import React, { useState,useEffect } from 'react';
import {  IonContent, IonGrid, IonRow, IonCol, IonText } from '@ionic/react';
import Params from './Params';
import Control from './Control';
import Resultado from './Resultado';
import Pie from './Pie';
import './Arbol.css';



const Arbol: React.FC = () => {
    const [result, setResult] = useState(21);
    const [params, setParams] = useState({
        numtas:120,
        numfc:80,
        numtfg:50,
        numk:5,
        tas:2,
        fc:2,
        tfg:3,
        k:1,
    });
    useEffect(() => {
        if(params.tas===1){
            if(params.fc===1){
              if(params.tfg===1){
                    setResult(1);
              }else if(params.tfg===2){
                if(params.k===1){
                  setResult(2);
                }else if(params.k===2){
                  setResult(3);
                }
              }else if(params.tfg===3){
                if(params.k===1){
                        setResult(4);
                }else if(params.k===2){
                        setResult(5);
                }
              }
            }else if(params.fc===2){
                  if(params.tfg===1){
                    setResult(6);
                  }else if(params.tfg===2){
                    if(params.k===1){
                      setResult(7);
                    }else if(params.k===2){
                      setResult(8);
                    }
                  }else if(params.tfg===3){
                    if(params.k===1){
                      setResult(9);
                    }else if(params.k===2){
                      setResult(10);
                    }
                  }
                }
        }else if(params.tas===2){
                if(params.fc===1){
                  if(params.tfg===1){
                    if(params.k===1){
                      setResult(11);
                    }else if(params.k===2){
                      setResult(12);
                    }
                  }else if(params.tfg===2){
                    if(params.k===1){
                      setResult(13);
                    }else if(params.k===2){
                      setResult(14);
                    }
                  }else if(params.tfg===3){
                    if(params.k===1){
                      setResult(15);
                    }else if(params.k===2){
                      setResult(16);
                    }
                  }
                }else if(params.fc===2){
                  if(params.tfg===1){
                    if(params.k===1){
                      setResult(17);
                    }else if(params.k===2){
                      setResult(18);
                    }
                  }else if(params.tfg===2){
                    if(params.k===1){
                      setResult(19);
                    }else if(params.k===2){
                      setResult(20);
                    }
                  }else if(params.tfg===3){
                    if(params.k===1){
                      setResult(21);
                    }else if(params.k===2){
                      setResult(22);
                    }
                  }
                }
        }
        console.log(params);
        console.log(result);

    }, [params])


    const handleTAS = (value:number ) =>{ 

        let valueproccesed=0;
        if(value>0 && value<100){
            valueproccesed=1
        }else if(value>=100){
            valueproccesed=2
        }
        setParams({...params, tas:valueproccesed,numtas:value }); };
    const handleFC = (value:number ) =>{ 
        let valueproccesed=0;
        if(value>0 && value<50){
            valueproccesed=1;
        }else if(value>=50){
            valueproccesed=2;
        }
        setParams({...params, fc:valueproccesed,numfc:value }); };
    const handleTFG = (value:number ) =>{ 
        let valueproccesed=0;
        if(value>0 && value<20){
            valueproccesed=1;
        }else if(value>=20 && value<30){
            valueproccesed=2;
        }else if(value>=30){
            valueproccesed=3;
        }
        setParams({...params, tfg:valueproccesed,numtfg:value }); };
    const handleK = (value:number ) =>{ 
        let valueproccesed=0;
        if(value>0 && value<5.5){
            valueproccesed=1;
        }else if(value>=5.5){
            valueproccesed=2;
        }
        setParams({...params, k:valueproccesed,numk:value }); };
        


    return (
    <IonContent className=" ">
                <IonGrid className="ion-padding-start ion-padding-end extra-padding ion-padding-bottom ion-margin-bottom">

      <IonText className="f1 mx2 pt2">Debe seleccionar los valores de tensión arterial sistólica, frecuencia cardíaca, tasa de filtrado glomerular y potasio</IonText>
      <IonRow>
        <IonCol size="6">
            <Control handler={handleTAS} title="TAS" description="Tensión arterial sistólica" name="tas" min={80} max={200} step={1} defaultValue={120} ></Control>
        </IonCol>
        <IonCol size="6">        
            <Control handler={handleFC} title="FC" description="Frecuencia cardíaca" name="fc"  min={40} max={120} step={1} defaultValue={80}></Control>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol size="6">
            <Control handler={handleTFG} title="TFG" description="Tasa de filtrado glomerular" name="tfg"  min={15} max={120} step={1} defaultValue={50} ></Control>
        </IonCol>
        <IonCol size="6">
            <Control handler={handleK} title="K+" description="potasio" name="k" min={3.5} max={6} step={0.1} defaultValue={5}></Control>
        </IonCol>
      </IonRow>


        {result>0 && <Resultado result={result}/>}

      
    </IonGrid>

    </IonContent>
  );
};

export default Arbol;
